export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/dtm-76308e1f2925327040a8f789fa42f979.png";